/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editCommands.vue?vue&type=template&id=45b0b3ba&scoped=true"
import script from "./editCommands.vue?vue&type=script&lang=js"
export * from "./editCommands.vue?vue&type=script&lang=js"
import style0 from "./editCommands.vue?vue&type=style&index=0&id=45b0b3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0b3ba",
  null
  
)

export default component.exports